// extracted by mini-css-extract-plugin
export default {"list":"floating-tabs_list__iPiF2","tab":"floating-tabs_tab__T3itu","indicator":"floating-tabs_indicator__Xs+Xf"};